export const search = {
  loading: false,
  term: '',
  items: [],
  focusIndex: '',
  focusUrl: '',

  async fetchAndUpdateSearch(event) {
    this.focusIndex = '';
    this.focusUrl = '';
    this.term = event.target.value.trim();
    this.loading = true;

    if (!this.term) {
      this.loading = false;
      this.items = [];
      return;
    }

    const requestUrl = `${window.Shopify.routes.root}search/suggest.json?q=${this.term}&resources[type]=product&resources[limit]=16&resources[options][fields]=title,product_type,variants.title,vendor,tag`;

    try {
      const response = await fetch(requestUrl);

      if (!response.ok) {
        throw new Error(response.status.toString());
      }

      const data = await response.json();
      this.items = data.resources.results.products ?? [];
    } catch (error) {
      console.error('Search error:', error);
    } finally {
      this.loading = false;
      this.focusIndex = '';
      this.focusUrl = '';
    }
  },

  updateSelected(increment) {
    if (this.focusIndex === '') {
      this.focusIndex = 0;
      this.focusUrl = this.items[0].url;
      return;
    }

    this.focusIndex = (this.focusIndex + increment + this.items.length) % this.items.length;
    this.focusUrl = this.items[this.focusIndex].url;
  },

  goToSelectedItem(formElement) {
    if (this.focusUrl === '') {
      formElement.submit();
      return;
    }

    window.location.href = this.focusUrl;
  },
};
